import { api } from "@/api/client";
import type { ApiListResponse } from "@/api/types";

export type ContactStatus = "NEW" | "READ" | "REPLIED" | "ARCHIVED";
/** Where the message came from: the contact page, or Enquire on a work. */
export type ContactType = "CONTACT" | "ENQUIRY";

export interface ContactSubmission {
  id: string;
  type: ContactType;
  /** The contact form asks for a name; the enquiry form does not. */
  name: string | null;
  email: string;
  phone: string | null;
  subject: string | null;
  message: string;
  status: ContactStatus;
  /** Filled in on enquiries only — the work as it was shown on the page. */
  workTitle: string | null;
  workArtist: string | null;
  workDetails: string | null;
  workImageUrl: string | null;
  pageUrl: string | null;
  newsletterOptIn: boolean;
  createdAt: string;
}

export interface ContactListQuery {
  page?: number;
  limit?: number;
  status?: string;
  type?: string;
  search?: string;
}

export const contactApi = {
  async list(query: ContactListQuery) {
    const { data } = await api.get<ApiListResponse<ContactSubmission>>("/contact", { params: query });
    return data;
  },
  async updateStatus(id: string, status: ContactStatus) {
    await api.patch(`/contact/${id}`, { status });
  },
  async remove(id: string) {
    await api.delete(`/contact/${id}`);
  },
};
